import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDownIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.25 6.125L8 9.875L11.75 6.125",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChevronDownIcon;
